
(function () {
  if (window.OSHKA_LIVE_RUNTIME_HOTFIX_20260616_V37) return;
  window.OSHKA_LIVE_RUNTIME_HOTFIX_20260616_V37 = true;

  // Shopify's product form requires this Dawn helper. Restore it when another
  // theme customization has removed it so add-to-cart cannot remain loading.
  if (typeof window.fetchConfig !== 'function') {
    window.fetchConfig = function (type) {
      type = type || 'json';
      return {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/' + type
        }
      };
    };
  }

  // Newer Dawn product forms call these optional performance helpers. Keep
  // cart behavior functional when the corresponding theme asset is missing.
  if (typeof window.CartPerformance !== 'object') {
    window.CartPerformance = {
      createStartingMarker: function () { return null; },
      measureFromMarker: function () {},
      measure: function (name, callback) { return typeof callback === 'function' ? callback() : undefined; },
      measureFromEvent: function () {}
    };
  }

  if (typeof window.onKeyUpEscape !== 'function') {
    window.onKeyUpEscape = function (event) {
      if (event && event.code !== 'Escape') return;
      var openDetails = event && event.target && event.target.closest && event.target.closest('details[open]');
      if (openDetails) openDetails.removeAttribute('open');
    };
  }

  function important(el, prop, value) {
    if (el) el.style.setProperty(prop, value, 'important');
  }

  function isHebrew() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('he') === 0 || location.pathname.indexOf('/he') === 0;
  }

  function updateShippingCopy() {
    var bar = document.querySelector('.announcement-bar__message, .announcement-bar');
    if (bar) {
      var text = isHebrew()
        ? 'קולקציית אביב/קיץ 2026 | משלוח בתוספת ₪35 | איסוף עצמי ללא עלות מהחנות'
        : 'NEW IN - Spring/Summer 2026 Collection | SHIPPING FEE ₪35 | FREE SELF PICKUP IN STORE';
      var target = bar.querySelector('span') || bar;
      if (String(target.textContent || '').trim() !== text) target.textContent = text;
    }
  }

  function rememberLanguageChoice() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      var input = form && form.querySelector && form.querySelector('[name="locale_code"]');
      if (input && input.value) localStorage.setItem('oshka-language-choice', input.value);
    }, true);
  }

  function applyDefaultHebrew() {
    if (isHebrew() || window.Shopify && Shopify.designMode) return;
    if (localStorage.getItem('oshka-language-choice')) return;
    var path = location.pathname === '/' ? '/' : location.pathname;
    location.replace('/he' + path + location.search + location.hash);
  }

  function compactCookie() {
    document.querySelectorAll('.oshka-cookie-popup-fixed').forEach(function (popup) {
      important(popup, 'box-sizing', 'border-box');
      important(popup, 'max-height', '42vh');
      important(popup, 'min-height', '0');
      important(popup, 'padding', '20px 26px 18px');
      important(popup, 'overflow-y', 'auto');
      var heading = popup.querySelector('h2');
      important(heading, 'font-family', 'Jost, Arial, Helvetica, sans-serif');
      important(heading, 'font-size', '22px');
      important(heading, 'line-height', '1.15');
      important(heading, 'margin', '0 0 12px');
      var paragraph = popup.querySelector('p');
      important(paragraph, 'font-family', 'Jost, Arial, Helvetica, sans-serif');
      important(paragraph, 'font-size', '14px');
      important(paragraph, 'line-height', '1.38');
      important(paragraph, 'margin', '0 auto 14px');
      var accept = popup.querySelector('.oshka-cookie-popup-fixed__accept');
      important(accept, 'min-height', '44px');
      important(accept, 'padding', '8px 26px');
      important(accept, 'font-size', '16px');
      var close = popup.querySelector('.oshka-cookie-popup-fixed__close');
      important(close, 'top', '10px');
      important(close, 'right', '14px');
      important(close, 'font-size', '30px');
    });
  }

  function translateAccount() {
    var text = isHebrew() ? '\u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA / \u05D4\u05E8\u05E9\u05DE\u05D4' : 'Log in / Sign up';
    document.querySelectorAll('#menu-drawer .menu-drawer__account').forEach(function (link) {
      var current = link.querySelector('.oshka-stable-login-text');
      if (!current || link.querySelectorAll('.oshka-stable-login-text').length !== 1) {
        link.innerHTML = '<span class="oshka-stable-login-text"></span><svg class="oshka-stable-account-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="7.5" r="3.5" stroke="currentColor" stroke-width="1.4"></circle><path d="M5.5 20c.5-4.1 2.8-6.2 6.5-6.2s6 2.1 6.5 6.2H5.5Z" stroke="currentColor" stroke-width="1.4"></path></svg>';
        current = link.querySelector('.oshka-stable-login-text');
      }
      if (current.textContent !== text) current.textContent = text;
      important(link, 'font-family', 'Jost, Arial, Helvetica, sans-serif');
      important(link, 'font-size', '18px');
      important(link, 'line-height', '1.18');
      important(link, 'white-space', 'nowrap');
    });
  }

  function normalizeMenu() {
    document.querySelectorAll(
      '#menu-drawer .menu-drawer__menu-item, #menu-drawer .menu-drawer__menu-item span, ' +
      '#menu-drawer .oshka-mobile-secondary-menu__link, #menu-drawer .menu-drawer__account, ' +
      '#menu-drawer .localization-form__select, #menu-drawer .disclosure__button'
    ).forEach(function (el) {
      important(el, 'font-family', 'Jost, Arial, Helvetica, sans-serif');
      important(el, 'font-size', '18px');
      important(el, 'line-height', '1.18');
      important(el, 'font-weight', '400');
      important(el, 'letter-spacing', '0');
      important(el, 'text-transform', 'uppercase');
    });
  }

  function normalizeMenuStructure() {
    var labels = {
      '#HeaderDrawer-home': 'HOME',
      '#HeaderDrawer-collection': 'COLLECTION',
      '#HeaderDrawer-sale': 'SALE',
      '#HeaderDrawer-sale-first-layer': 'SALE'
    };
    Object.keys(labels).forEach(function (selector) {
      document.querySelectorAll('#menu-drawer ' + selector).forEach(function (item) {
        var textNode = Array.prototype.find.call(item.childNodes, function (node) {
          return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
        });
        if (textNode) textNode.textContent = labels[selector];
        else {
          var span = item.querySelector('span');
          if (span) span.textContent = labels[selector];
        }
      });
    });

    var collection = document.querySelector('#menu-drawer #HeaderDrawer-collection');
    var details = collection && collection.closest('details');
    var submenu = details && details.querySelector('.menu-drawer__inner-submenu > ul.menu-drawer__menu');
    if (submenu && !submenu.querySelector('#HeaderDrawer-collection-holiday')) {
      submenu.innerHTML =
        '<li><a id="HeaderDrawer-collection-new-in" href="/collections/new-in" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">New In</a></li>' +
        '<li><a id="HeaderDrawer-collection-holiday" href="/collections/holiday" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Holiday</a></li>' +
        '<li><a id="HeaderDrawer-collection-best-sellers" href="/collections/best-sellers" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Best Sellers</a></li>' +
        '<li><a id="HeaderDrawer-collection-ruya" href="/collections/ruya" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Rüya</a></li>';
    }
  }

  function fixViewportHeaderAndFonts() {
    if (!document.getElementById('oshka-runtime-polish-v29-style')) {
      var style = document.createElement('style');
      style.id = 'oshka-runtime-polish-v29-style';
      style.textContent =
        'html,body{max-width:100%!important;overflow-x:hidden!important;}' +
        '#menu-drawer{width:100vw!important;max-width:100vw!important;overflow-x:hidden!important;}' +
        '#menu-drawer .menu-drawer__navigation,#menu-drawer .menu-drawer__inner-container{width:100%!important;max-width:100%!important;overflow-x:hidden!important;}' +
        '#menu-drawer .menu-drawer__menu,#menu-drawer .oshka-mobile-secondary-menu{padding-left:24px!important;padding-right:24px!important;box-sizing:border-box!important;}' +
        '#menu-drawer .menu-drawer__menu-item,#menu-drawer .oshka-mobile-secondary-menu__link,#menu-drawer .menu-drawer__account{font-family:Jost,Arial,Helvetica,sans-serif!important;font-size:18px!important;line-height:1.18!important;font-weight:400!important;letter-spacing:0!important;text-transform:uppercase!important;}' +
        '#menu-drawer .menu-drawer__account{display:inline-flex!important;align-items:center!important;gap:10px!important;max-width:100%!important;white-space:nowrap!important;}' +
        '#menu-drawer .list-social__link,#menu-drawer .list-social__link *,footer .list-social__link,footer .list-social__link *{text-decoration:none!important;border-bottom:0!important;box-shadow:none!important;}' +
        '.header__heading,.header__heading-link{position:absolute!important;left:50%!important;transform:translateX(-50%)!important;text-align:center!important;}' +
        '.product__title,.product__title h1,.product__info-container .product__title,.product__info-container h1{font-family:Jost,Arial,Helvetica,sans-serif!important;letter-spacing:0!important;text-transform:uppercase!important;}' +
        '.g-variant-color .swatches-options,.g-variant-color-detail .select-option{width:24px!important;height:24px!important;min-width:24px!important;min-height:24px!important;margin-inline-end:14px!important;overflow:visible!important;}' +
        '.g-variant-color label.swatch-anchor,.g-variant-color-detail label.swatch-anchor,.card__swatch-dot{box-sizing:border-box!important;overflow:hidden!important;background-clip:padding-box!important;}' +
        '.card__swatch-dot[style*="url"],.card__swatch-dot[style*="image"]{display:none!important;}';
      (document.head || document.documentElement).appendChild(style);
    }
  }

  function ensureMenuCategories() {
    var drawer = document.querySelector('#menu-drawer');
    if (!drawer) return;
    var nav = drawer.querySelector('.menu-drawer__navigation');
    if (!nav) return;
    var old = drawer.querySelector('#oshka-primary-menu-v29');
    if (!old) {
      var firstList = nav.querySelector('ul.menu-drawer__menu');
      var block = document.createElement('ul');
      block.id = 'oshka-primary-menu-v29';
      block.className = 'menu-drawer__menu list-menu';
      block.innerHTML =
        '<li><a id="HeaderDrawer-home" href="/he/" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">HOME</a></li>' +
        '<li><details><summary id="HeaderDrawer-collection" class="menu-drawer__menu-item list-menu__item link link--text focus-inset">COLLECTION <span aria-hidden="true">→</span></summary><div class="menu-drawer__submenu"><ul class="menu-drawer__menu list-menu" role="list">' +
        '<li><a href="/he/collections/new-in" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">New In</a></li>' +
        '<li><a href="/he/collections/holiday" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Holiday</a></li>' +
        '<li><a href="/he/collections/best-sellers" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Best Sellers</a></li>' +
        '<li><a href="/he/collections/ruya" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Rüya</a></li>' +
        '</ul></div></details></li>' +
        '<li><a id="HeaderDrawer-sale" href="/he/collections/sale" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">SALE</a></li>';
      if (firstList) nav.insertBefore(block, firstList);
      else nav.insertBefore(block, nav.firstChild);
      drawer.querySelectorAll('#HeaderDrawer-home, #HeaderDrawer-collection, #HeaderDrawer-sale, #HeaderDrawer-sale-first-layer').forEach(function (item) {
        if (!item.closest('#oshka-primary-menu-v29')) {
          var li = item.closest('li');
          if (li) li.remove();
        }
      });
    }
    drawer.querySelectorAll('a, summary').forEach(function (item) {
      var text = String(item.textContent || '').replace(new RegExp('\\s+', 'g'), ' ').trim();
      if (text === 'מבצע' || text === 'סייל') item.textContent = 'SALE';
      if (text === 'שאלות נפוצות') item.textContent = 'FAQ';
    });
    var secondaryLabels = [
      [new RegExp('/pages/store(?:$|[?#])|/pages/store-1(?:$|[?#])'), 'STORE'],
      [new RegExp('/pages/contact(?:$|[?#])'), 'CONTACT US'],
      [new RegExp('/pages/about-us(?:$|[?#])'), 'ABOUT US'],
      [new RegExp('/pages/faq(?:$|[?#])'), 'FAQ'],
      [new RegExp('/products/gift-card|/pages/gift-card'), 'GIFT CARD']
    ];
    drawer.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      secondaryLabels.some(function (pair) {
        if (pair[0].test(href)) {
          link.textContent = pair[1];
          return true;
        }
        return false;
      });
    });
  }

  function normalizeSocialLinks() {
    document.querySelectorAll('#menu-drawer .list-social__link, footer .list-social__link, #menu-drawer .list-social a, footer .list-social a').forEach(function (link) {
      important(link, 'text-decoration', 'none');
      important(link, 'border-bottom', '0');
      important(link, 'box-shadow', 'none');
      link.querySelectorAll('*').forEach(function (child) {
        important(child, 'text-decoration', 'none');
        important(child, 'border-bottom', '0');
        important(child, 'box-shadow', 'none');
      });
    });
    document.querySelectorAll('#menu-drawer .list-social, footer .list-social').forEach(function (list) {
      if (list.querySelector('a[href*="wa.me"], a[href*="whatsapp"]')) return;
      var li = document.createElement('li');
      li.className = 'list-social__item oshka-social-whatsapp';
      li.innerHTML = '<a href="https://wa.me/message/LG2CVB43ID2NE1" class="list-social__link link" target="_blank" rel="noopener" aria-label="WhatsApp"><span style="font-family:Jost,Arial,sans-serif;font-size:20px;line-height:1;text-decoration:none!important;border:0!important;">WA</span></a>';
      list.appendChild(li);
    });
    document.querySelectorAll('#menu-drawer .oshka-mobile-social, .menu-drawer .oshka-mobile-social').forEach(function (list) {
      if (list.querySelector('a[href*="wa.me"], a[href*="whatsapp"]')) return;
      var link = document.createElement('a');
      link.href = 'https://wa.me/message/LG2CVB43ID2NE1';
      link.className = 'oshka-ms-link oshka-ms-whatsapp';
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-label', 'WhatsApp');
      link.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="22" height="22" aria-hidden="true"><path d="M20 11.5a8 8 0 0 1-11.9 7L4 20l1.4-4.2A8 8 0 1 1 20 11.5Z"></path><path d="M8.6 8.3c.2-.4.4-.4.7-.4h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2.1.4 0 .6-.2.3-.4.5-.6.8-.1.1-.2.3-.1.5.4.8 1 1.5 1.7 2 .8.6 1.4.8 1.6.9.2.1.4 0 .5-.1l.8-1c.2-.2.4-.2.6-.1l1.9.9c.3.1.4.3.4.5 0 .5-.4 1.5-1 1.9-.6.4-1.4.5-2.3.3-2-.4-4.1-1.7-5.7-3.3-1.5-1.5-2.7-3.6-3-5.1-.1-.8 0-1.5.4-2 .3-.4.8-.7 1.2-.7Z"></path></svg>';
      list.appendChild(link);
    });
  }

  function normalizeFindMySizeText() {
    var wanted = isHebrew() ? 'מצאי את המידה שלך' : 'Find My Size';
    document.querySelectorAll('a, button, summary, .oshka-size-helper-trigger').forEach(function (element) {
      var text = String(element.textContent || '').replace(new RegExp('\\s+', 'g'), ' ').trim().toLowerCase();
      if (text === 'find my size' || text === 'מצאי את המידה שלי' || text === 'מצאי מידה') {
        element.textContent = wanted;
      }
    });
  }

  function normalizeSearchAndCheckoutRoutes() {
    var isHe = isHebrew();
    function mapSearchTerm(value) {
      var v = String(value || '').trim();
      var map = [
        [/שמל(ה|ות)/i, 'dress'],
        [/חליפ(ה|ות)/i, 'suit'],
        [/חצאית/i, 'skirt'],
        [/חגור/i, 'belt'],
        [/מחוך/i, 'corset'],
        [/טופ|חולצ/i, 'top']
      ];
      for (var i = 0; i < map.length; i += 1) {
        if (map[i][0].test(v)) return map[i][1];
      }
      return v;
    }
    if (location.pathname.indexOf('/search') !== -1) {
      var params = new URLSearchParams(location.search);
      var currentQuery = params.get('q') || '';
      var mappedQuery = mapSearchTerm(currentQuery);
      if (mappedQuery && mappedQuery !== currentQuery && params.get('oshka_search_mapped') !== '1') {
        params.set('q', mappedQuery);
        params.set('oshka_search_mapped', '1');
        location.replace(location.pathname + '?' + params.toString() + location.hash);
        return;
      }
    }
    document.querySelectorAll('form[action*="/search"], form[action="/he/search"], form[action="/search"]').forEach(function (form) {
      if (form.dataset.oshkaSearchMapped) return;
      form.dataset.oshkaSearchMapped = 'true';
      form.addEventListener('submit', function () {
        var q = form.querySelector('[name="q"]');
        if (!q) return;
        q.value = mapSearchTerm(q.value);
      }, { capture: true });
    });
    document.querySelectorAll('form[action*="/checkout"], a[href*="/checkout"], button[name="checkout"]').forEach(function (element) {
      if (element.tagName === 'FORM') {
        if (isHe) element.action = '/checkout?locale=he-IL';
      } else if (element.tagName === 'A') {
        if (isHe) element.setAttribute('href', '/checkout?locale=he-IL');
      }
    });
  }

  function normalizeStaticPageCopy() {
    var path = String(location.pathname || '').toLowerCase();
    var isFaq = path.indexOf('/pages/faq') !== -1;
    var isStore = path.indexOf('/pages/store') !== -1;
    if (!isFaq && !isStore) return;
    var rte = document.querySelector('main .rte');
    if (!rte || rte.dataset.oshkaStaticCopyFixed === 'true') return;
    rte.dataset.oshkaStaticCopyFixed = 'true';
    var he = isHebrew();
    if (isFaq) {
      rte.innerHTML = he ? [
        '<h3>משלוחים</h3>',
        '<p><strong>כמה זמן לוקח משלוח?</strong><br>משלוחים מגיעים בדרך כלל תוך 1-14 ימי עסקים. בתקופות עומס, השקות או חגים ייתכנו עיכובים קלים.</p>',
        '<p><strong>מה עלות המשלוח?</strong><br>משלוח עד הבית בעלות קבועה של 35 ש"ח.</p>',
        '<p><strong>האם אפשר איסוף עצמי?</strong><br>כן. ניתן לבחור איסוף עצמי ללא עלות מהחנות: הציונות 4, קריית היובל, ירושלים.</p>',
        '<h3>החזרות והחלפות</h3>',
        '<p>ניתן לבצע החזרה או החלפה עד 14 ימים מקבלת ההזמנה, בהתאם למדיניות ההחזרות וההחלפות של OSHKA. הפריט חייב להיות חדש, לא בשימוש, לא מכובס, ללא פגם ועם הטיקט/האריזה המקוריים.</p>',
        '<p>לפני החזרה או החלפה יש ליצור איתנו קשר כדי שנוכל לאשר את הבקשה ולהנחות אותך בתהליך.</p>',
        '<p><a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">יצירת קשר בוואטסאפ</a></p>',
        '<h3>תשלום</h3>',
        '<p>אנחנו מקבלות תשלומים מאובטחים באמצעי התשלום שמופיעים בצ׳קאאוט. נכון לעכשיו אין תשלום דרך PayPal.</p>',
        '<h3>יצירת קשר</h3>',
        '<p>אימייל: officialoshka@gmail.com<br>וואטסאפ: <a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">OSHKA WhatsApp</a></p>'
      ].join('') : [
        '<h3>Shipping</h3>',
        '<p><strong>How long does shipping take?</strong><br>Orders usually arrive within 1-14 business days. During launches, holidays, or high-volume periods, slight delays may occur.</p>',
        '<p><strong>How much does shipping cost?</strong><br>Home delivery has a fixed fee of ₪35.</p>',
        '<p><strong>Can I choose self pickup?</strong><br>Yes. Free self pickup is available from our store: HaTziyonut 4, Kiryat HaYovel, Jerusalem.</p>',
        '<h3>Returns & Exchanges</h3>',
        '<p>Returns or exchanges are available within 14 days of receiving the order, according to OSHKA\'s returns and exchanges policy. Items must be new, unused, unwashed, undamaged, and with original tags/packaging.</p>',
        '<p>Before returning or exchanging an item, please contact us so we can approve the request and guide you through the process.</p>',
        '<p><a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">Contact us on WhatsApp</a></p>',
        '<h3>Payment</h3>',
        '<p>We accept secure payments through the payment methods shown at checkout. PayPal is currently not available.</p>',
        '<h3>Contact</h3>',
        '<p>Email: officialoshka@gmail.com<br>WhatsApp: <a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">OSHKA WhatsApp</a></p>'
      ].join('');
    }
    if (isStore) {
      rte.innerHTML = he ? [
        '<p><strong>כתובת:</strong> הציונות 4, קריית היובל, ירושלים</p>',
        '<p><strong>איסוף עצמי:</strong> ניתן לבחור איסוף עצמי ללא עלות מהחנות.</p>',
        '<p><a href="https://maps.app.goo.gl/UbLPJAv8fjX51aBZ6?g_st=ic" target="_blank" rel="noopener">פתיחה בגוגל מפות</a></p>',
        '<p><a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">תיאום הגעה בוואטסאפ</a></p>'
      ].join('') : [
        '<p><strong>Address:</strong> HaTziyonut 4, Kiryat HaYovel, Jerusalem</p>',
        '<p><strong>Self pickup:</strong> Free self pickup is available from our store.</p>',
        '<p><a href="https://maps.app.goo.gl/UbLPJAv8fjX51aBZ6?g_st=ic" target="_blank" rel="noopener">Open in Google Maps</a></p>',
        '<p><a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">Schedule arrival on WhatsApp</a></p>'
      ].join('');
    }
  }

  function normalizeBag() {
    document.querySelectorAll('svg.oshka-clean-bag-icon').forEach(function (bag) {
      important(bag, 'width', '29px');
      important(bag, 'height', '29px');
      var paths = bag.querySelectorAll('path');
      if (paths[0]) paths[0].setAttribute('d', 'M18 27H46V52H18V27Z');
      if (paths[1]) paths[1].setAttribute('d', 'M24 30V20C24 13.4 27.6 9 32 9C36.4 9 40 13.4 40 20V30');
      paths.forEach(function (path) {
        path.setAttribute('stroke-width', '1.8');
        important(path, 'stroke-width', '1.8px');
        important(path, 'vector-effect', 'non-scaling-stroke');
      });
    });
  }

  function normalizeCardBags() {
    document.querySelectorAll('.card__bag-icon').forEach(function (link) {
      important(link, 'width', '38px');
      important(link, 'height', '38px');
      important(link, 'top', '12px');
      important(link, 'right', '12px');
      var bag = link.querySelector('svg');
      if (!bag) return;
      bag.setAttribute('viewBox', '0 0 64 64');
      bag.setAttribute('width', '28');
      bag.setAttribute('height', '28');
      important(bag, 'width', '28px');
      important(bag, 'height', '28px');
      important(bag, 'overflow', 'visible');
      var paths = bag.querySelectorAll('path');
      if (paths[0]) paths[0].setAttribute('d', 'M18 27H46V52H18V27Z');
      if (paths[1]) paths[1].setAttribute('d', 'M24 30V20C24 13.4 27.6 9 32 9C36.4 9 40 13.4 40 20V30');
      paths.forEach(function (path) {
        path.setAttribute('stroke-width', '1.7');
        important(path, 'stroke-width', '1.7px');
        important(path, 'vector-effect', 'non-scaling-stroke');
      });
    });
  }

  var collarStylesPromise;
  function renderRelatedStyleSwatches() {
    document.querySelectorAll('.oshka-related-style-swatches').forEach(function (wrapper) {
      wrapper.remove();
    });
  }

  function swatchColor(value) {
    var colors = {
      'white': '#f7f5ef',
      'off white': '#f7f5ef',
      'ivory': '#f4efe4',
      'cream': '#efe6d7',
      'black': '#000000',
      'black (silver buckle)': '#000000',
      'שחור': '#000000',
      'שחור (אבזם כסף)': '#000000',
      'לבן': '#f7f5ef',
      'תחרה לבנה': '#f7f5ef',
      'שמנת': '#efe6d7',
      'wine red': '#8b1024',
      'burgundy': '#8b1024',
      'בורדו': '#8b1024',
      'יין': '#8b1024',
      'אדום יין': '#8b1024',
      'brown': '#7a3f22',
      'brown (gold buckle)': '#7a3f22',
      'חום': '#7a3f22',
      'חום (אבזם זהב)': '#7a3f22',
      'chocolate brown': '#442117',
      'חום שוקולד': '#442117',
      'dark brown': '#321812',
      'reddish brown': '#7a2d1d',
      'חום אדמדם': '#7a2d1d',
      'stone': '#bcb3a6',
      'אבן': '#bcb3a6',
      'beige': '#c8baa7',
      'בז׳': '#c8baa7',
      'בז': '#c8baa7',
      'dark teal': '#064f4f',
      'טורקיז כהה': '#064f4f',
      'teal': '#0d6762',
      'טורקיז': '#0d6762'
    };
    return colors[String(value || '').trim().toLowerCase()] || '#d7d7d7';
  }

  function paintSwatches() {
    document.querySelectorAll('.g-variant-color .swatches-options, .g-variant-color-detail .select-option').forEach(function (item) {
      var input = item.querySelector('input[type="radio"]');
      var label = item.querySelector('label.swatch-anchor');
      if (!label) return;
      var value = (input && input.value) || item.getAttribute('data-value') || label.getAttribute('title') || '';
      var color = swatchColor(value);
      important(item, '--oshka-swatch-color', color);
      important(label, '--oshka-swatch-color', color);
      important(label, 'background', color);
      important(label, 'background-color', color);
      important(label, 'background-image', 'none');
      important(label, 'width', '22px');
      important(label, 'height', '22px');
      important(label, 'min-width', '22px');
      important(label, 'min-height', '22px');
      important(label, 'max-width', '22px');
      important(label, 'max-height', '22px');
      important(label, 'border-radius', '50%');
      important(label, 'border', input && input.checked ? '2px solid #111' : '1px solid rgba(17,17,17,.3)');
      important(label, 'box-shadow', 'none');
      important(label, 'transform', 'none');
      important(label, 'transition', 'none');
      label.setAttribute('aria-checked', input && input.checked ? 'true' : 'false');
    });
  }

  function paintCardSwatches() {
    document.querySelectorAll('.card__swatch-dot').forEach(function (dot) {
      var value = dot.getAttribute('title') || dot.getAttribute('aria-label') || '';
      var color = swatchColor(value);
      important(dot, 'background', color);
      important(dot, 'background-color', color);
      important(dot, 'background-image', 'none');
      important(dot, 'width', '22px');
      important(dot, 'height', '22px');
      important(dot, 'min-width', '22px');
      important(dot, 'min-height', '22px');
      important(dot, 'max-width', '22px');
      important(dot, 'max-height', '22px');
      important(dot, 'border-radius', '50%');
      important(dot, 'transform', 'none');
      important(dot, 'transition', 'none');
    });
  }

  function cleanCartPickupDuplicates() {
    document.querySelectorAll('.oshka-pickup-schedule-box').forEach(function (box) {
      box.remove();
    });
    var notes = Array.prototype.slice.call(document.querySelectorAll('.oshka-cart-shipping-note'));
    notes.forEach(function (note, index) {
      if (index > 0) note.remove();
    });
  }

  function hideBeltDressSizeHelper() {
    var path = String(location.pathname || '');
    if (path.indexOf('/he/') === 0) path = path.slice(3);
    if (path !== '/products/belt-dress' && path.indexOf('/products/belt-dress/') !== 0) return;
    document.documentElement.setAttribute('data-oshka-belt-dress', 'true');
    if (!document.getElementById('oshka-hide-belt-size-helper')) {
      var style = document.createElement('style');
      style.id = 'oshka-hide-belt-size-helper';
      style.textContent = '[data-oshka-belt-dress="true"] .oshka-size-helper-slot,[data-oshka-belt-dress="true"] .oshka-size-helper-trigger,[data-oshka-belt-dress="true"] .oshka-size-helper-overlay{display:none!important}';
      (document.head || document.documentElement).appendChild(style);
    }
    document.querySelectorAll('.oshka-size-helper-slot, .oshka-size-helper-trigger, .oshka-size-helper-overlay').forEach(function (element) {
      important(element, 'display', 'none');
    });
    document.querySelectorAll('a, button').forEach(function (element) {
      var text = String(element.textContent || '').replace(new RegExp('\\s+', 'g'), ' ').trim().toLowerCase();
      if (text === 'find my size' || text === 'מצאי את המידה שלי' || text === 'מצאי מידה') {
        important(element, 'display', 'none');
      }
    });
  }

  var productPromise;
  function focusVariantImage(input) {
    if (!input || location.pathname.indexOf('/products/') !== 0) return;
    var item = input.closest('.select-option');
    var variantId = item && item.getAttribute('data-variantid');
    if (!variantId) return;
    productPromise = productPromise || fetch(location.pathname + '.js').then(function (response) { return response.json(); });
    productPromise.then(function (product) {
      var variant = product.variants && product.variants.find(function (candidate) { return String(candidate.id) === String(variantId); });
      var mediaId = variant && variant.featured_media && variant.featured_media.id;
      if (!mediaId) return;
      var media = document.querySelector('.product__media-item[data-media-id$="-' + mediaId + '"]');
      var imageUrl = variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src;
      if (!media && imageUrl) {
        var activeMedia = document.querySelector('.product__media-item.is-active') || document.querySelector('.product__media-item');
        var activeImage = activeMedia && activeMedia.querySelector('img');
        if (activeImage) {
          activeImage.removeAttribute('srcset');
          activeImage.src = imageUrl;
          activeImage.alt = variant.featured_media.alt || activeImage.alt || '';
          activeMedia.setAttribute('data-oshka-variant-media-id', String(mediaId));
        }
      }
      var gallery = media && media.closest('media-gallery');
      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(media.getAttribute('data-media-id'), true);
        return;
      }
      var thumbnail = document.querySelector('[data-target$="-' + mediaId + '"] button.thumbnail');
      if (media) {
        document.querySelectorAll('.product__media-item.is-active').forEach(function (item) { item.classList.remove('is-active'); });
        media.classList.add('is-active');
        var list = media.parentElement;
        if (list && typeof list.scrollTo === 'function') list.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
      }
      document.querySelectorAll('.thumbnail[aria-current="true"]').forEach(function (button) { button.removeAttribute('aria-current'); });
      if (thumbnail) {
        thumbnail.setAttribute('aria-current', 'true');
      }
    }).catch(function () {});
  }

  function run() {
    updateShippingCopy();
    compactCookie();
    translateAccount();
    fixViewportHeaderAndFonts();
    ensureMenuCategories();
    normalizeSocialLinks();
    normalizeFindMySizeText();
    normalizeSearchAndCheckoutRoutes();
    normalizeStaticPageCopy();
    normalizeMenuStructure();
    normalizeMenu();
    normalizeBag();
    normalizeCardBags();
    renderRelatedStyleSwatches();
    paintSwatches();
    paintCardSwatches();
    cleanCartPickupDuplicates();
    hideBeltDressSizeHelper();
  }

  rememberLanguageChoice();
  applyDefaultHebrew();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  document.addEventListener('click', function (event) {
    var label = event.target && event.target.closest && event.target.closest('.g-variant-color-detail label.swatch-anchor');
    var input = label && label.htmlFor && document.getElementById(label.htmlFor);
    if (input) setTimeout(function () { focusVariantImage(input); }, 80);
    setTimeout(run, 20);
    setTimeout(paintSwatches, 180);
    setTimeout(paintCardSwatches, 180);
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('.g-variant-color-detail input[type="radio"]')) focusVariantImage(event.target);
    setTimeout(paintSwatches, 20);
    setTimeout(paintCardSwatches, 20);
  }, true);
  [100, 350, 900, 1800, 3500].forEach(function (ms) { setTimeout(run, ms); });
  new MutationObserver(function (mutations) {
    if (mutations.some(function (m) { return m.addedNodes && m.addedNodes.length; })) requestAnimationFrame(run);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
